/**
 * Module-level app config populated once from /api/config at startup.
 * Not reactive — values are correct from the moment the app renders.
 */
export const appConfig = {
  debugAuthLogging: false,
  useClerkNativeSignin: true,
};

export function applyAppConfig(data) {
  if (!data) return;
  appConfig.debugAuthLogging = Boolean(data.debug_auth_logging);
  appConfig.useClerkNativeSignin = Boolean(data.use_clerk_native_signin);
}
